import React from 'react'
import { twMerge } from 'tailwind-merge'
import ImageMedia from './ImageMedia'

const DefaultContent = ({ className, title }) => {
  return (
    <div id={title} className={twMerge('flex center full= h-[100%]= p-3 full bg-gradient-to-t  from-primary to-red-600/60', className)}>
      <ImageMedia bypass
        className="size-[4rem] m-auto self-center object-contain pointer-events-none flex center"
        src={require('../../assets/branding/L.png')}
      />
    </div>
  )
}

export default DefaultContent